<div class="container-fluid padMob webView" style="padding-left: 15px; padding-right: 0px;" id="excel-table">
    <div class="row ">
        <div class="col-md-12 col-12 col-sm-12 pad0 padHeder" style="padding-bottom: 0px; padding-top: 15px;">
            <div class="col-md-3 col-12 col-sm-12 inLneBlk lblHeader" style="display: inline-block;">
                <h4> GSTR-3B Summary</h4>
            </div>
            <div class="col-md-9 col-12 col-sm-12 inLneBlk" style="display: inline-block;text-align: right; padding-right: 50px;">
                <div style="display: inline-block; margin-right: 10px;" *ngIf="isEGST">
                        <select class="form-control formCtlFltr brdrRadius3" style="width: 140px; background-color: #fff !important; cursor: pointer;"
                        [(ngModel)]="selectedGST" (change)="getListData();">
                               <option *ngFor="let g of gstLocations"value="{{g.GST}}">
                                        {{g.GST}}
                                </option>
                        </select>
                </div>
                <div style="display: none;">
                        <label>Month : </label>
                        <select [(ngModel)]="month" (change) = "selectMonth()" class="form-control" style="display: inline-flex;width: 10%;">
                                <option *ngFor="let month of months" >
                                  {{month}}
                                </option>
                        </select>
                        <select [(ngModel)]="year" (change) ="getListData()" class="form-control" style="margin-right: 30px;display: inline-flex;width: 14%;margin-left: 10px;">
                                <option *ngFor="let year of years" >
                               {{year}}
                                </option>
                        </select> 
                </div>

                <div style="display: inline-block;">
                        <!-- This Quarter -->
                        <span class="newOrangeBadge lnHgt {{period == 1 ? 'activeNewOrangeBadge' : ''}}" style="cursor: pointer; padding: {{period == 1 ? '3px 10px' : ''}}; font-size: 13px; margin-right: 5px;" (click)="changeFilter(1)">
                                <span style="font-size: 12px; font-weight: 600;"> This Quarter</span>
                        </span>
                        <!-- Prev Quarter -->
                        <span class="newOrangeBadge lnHgt {{period == 2 ? 'activeNewOrangeBadge' : ''}}" style="cursor: pointer; padding: {{period == 2 ? '3px 10px' : ''}}; font-size: 13px; margin-right: 5px;" (click)="changeFilter(2)">
                                <span style="font-size: 12px; font-weight: 600;"> Prev Quarter</span>
                        </span>
                        <!-- Other -->
                        <span class="newOrangeBadge lnHgt {{period == 3 ? 'activeNewOrangeBadge' : ''}}" style="cursor: pointer; padding: {{period == 3 ? '3px 10px' : ''}}; font-size: 13px; margin-right: 5px;" (click)="changeFilter(3)">
                                <span style="font-size: 12px; font-weight: 600;">Month </span>
                        </span>
                </div>

                <span *ngIf="period == 3">
                        <span> : </span>
                        <select [(ngModel)]="selectedMonthID" (change) = "selectMonth()" class="form-control formCtlFltr brdrRadius3"
                                style="display: inline-flex;width: 13%; cursor: pointer; margin-left: 5px; background-color: #fff !important;">
                                <option *ngFor="let month of monthList"value="{{month.id}}">
                                        {{month.display}}
                                </option>
                        </select>
                </span>
                
                <span class="btn btn-orange brdrRadius3" style="padding: 3px 14px 3px; font-size: 14px; margin-left: 10px; line-height: 1.66em;"(click) = "exportJson()"  title="GSTR3B JSON">
                <i class="fa fa-code" style="margin-right: 5px;"></i> GSTR3B JSON
                </span>
            </div>
        </div>


        <div class="col-md-12 col-12 col-sm-12 pad0" style="padding:15px;">

            <!-- table 1 -->
            <label style="width: 97%;" class="lblFont">3.1 Details of outward supplies and inward supplies liable to reverse charge</label>
            <table class="table table-borderd ngTable" data-show-filter="true" id="productListTbl"
                style="margin-bottom: 10px; width: 97%; background: white;">
                <thead>
                    <tr class="trBg">
                        <th style="width: 50%;">Nature of Supply</th>
                        <th style="width: 10%;">Taxable Amt</th>
                        <th style="width: 10%;"> IGST</th>
                        <th style="width: 10%;">CGST</th>
                        <th style="width: 10%;">SGST</th>
                        <th style="width: 10%;">CESS Tax</th>
                    </tr>
                </thead>
                <tbody>
                    <tr style="cursor: pointer;" *ngFor="let x of supDetailArr " >
                        <td>{{x.type}}</td>
                        <td style="text-align: right;"><input style="width: 100px; outline: none;" class="form-control brdr" [(ngModel)]="x.txval"  (keyup) ="changesupDetailArr($event)" (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px; outline: none;" class="form-control brdr" [(ngModel)]="x.iamt"  (keyup) ="changesupDetailArr($event)" (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px; outline: none;" class="form-control brdr" [(ngModel)]="x.camt"  (keyup) ="changesupDetailArr($event)"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px; outline: none;" class="form-control brdr" [(ngModel)]="x.samt"  (keyup) ="changesupDetailArr($event)" (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px; outline: none;" class="form-control brdr" [(ngModel)]="x.csamt"   (keyup) ="changesupDetailArr($event)" (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                    </tr>
                    <!-- <tr style="cursor: pointer;">
                        <td>(b) Outward taxable supplies (zero-rated)</td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                    </tr>
                    <tr style="cursor: pointer;">
                        <td>(c) Other outward supplies (nil-rated, exempted)</td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                    </tr>
                    <tr style="cursor: pointer;">
                        <td>(d) Inward supplies (liable to reverse charge)</td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                    </tr>
                    <tr style="cursor: pointer;">
                        <td>(e) Non-GST outward supplies</td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                    </tr> -->

                </tbody>
            </table>

            <!-- table 2 -->
            <label style="margin-top:20px;width: 97%;" class="lblFont">3.2 Of the supplies shown in 3.1(a) above, details of inter-State supplies
                made to unregistered persons, composition taxable persons and UIN holders</label>
            <table class="table table-borderd ngTable" data-show-filter="true" id="productListTbl"
                style="margin-bottom: 10px;width: 97%; background: white;">
                <thead>
                    <tr class="trBg">
                        <th></th>
                        <th style="width: 200px;">Place of Supply</th>
                        <th style="width: 200px;">Taxable Amt</th>
                        <th style="width: 200px;"> IGST</th>
                    </tr>
                </thead>
                <tbody>
                    <tr style="cursor: pointer;" *ngFor="let x of interSupArr; let i = index ">
                        <td> {{x.type}}</td>
                        <td style="text-align: right;">
                            <input style="width: 200px; outline: none;" class="form-control" list="stateList" [(ngModel)]="x.state" (blur)="setState(x.state, i)" 
                                type="text">
                                <datalist id="stateList">
                                    <option *ngFor="let x of stateList | sort : 'stateName' : 0" [value]="x.stateName"></option>
                                </datalist> 
            
                            </td>
                        <td style="text-align: right;">
                                <input style="width: 200px; outline: none;" class="form-control brdr" [(ngModel)]="x.txval" (keyup) ="changeinterSupArr($event)"  (keypress)="CmnService.numberOnly($event)"
                                type="text">
                        </td>
                        <td style="text-align: right;">
                                <input style="width: 200px; outline: none;" class="form-control brdr" [(ngModel)]="x.iamt" (keyup) ="changeinterSupArr($event)" (keypress)="CmnService.numberOnly($event)"
                                type="text">
                        </td>
                    </tr>
                    <!-- <tr style="cursor: pointer;">
                        <td>Supplies made to Compostion Taxable Persons</td>
                        <td style="text-align: right;">
                                <input style="width: 200px;outline: none;" class="brdr" list="stateList"
                                type="text">
                                <datalist id="stateList">
                                    <option *ngFor="let x of stateList" [value]="x.stateName"></option>
                                </datalist> 

                            </td>
                        <td style="text-align: right;"><input style="width: 200px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 200px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                    </tr>
                    <tr style="cursor: pointer;">
                        <td>Supplies made to UIN holders</td>
                        <td style="text-align: right;">
                                <input style="width: 200px;outline: none;" class="brdr" list="stateList"
                                type="text">
                                <datalist id="stateList">
                                    <option *ngFor="let x of stateList" [value]="x.stateName"></option>
                                </datalist> 

                            </td>
                        <td style="text-align: right;"><input style="width: 200px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 200px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                    </tr> -->
                </tbody>

            </table>

            <!-- table 3 -->
            <label style="margin-top:20px;width: 97%;" class="lblFont">4. Eligible ITC</label>
            <table class="table table-borderd ngTable" data-show-filter="true" id="productListTbl"
                style="margin-bottom: 10px;width: 97%; background: white;">
                <thead>
                    <tr class="trBg">
                        <th>Details</th>
                        <th style="width: 100px;"> IGST</th>
                        <th style="width: 100px;">CGST</th>
                        <th style="width: 100px;">SGST</th>
                        <th style="width: 100px;">CESS Tax</th>
                    </tr>
                </thead>
                <tbody>

                    <!-- first -->
                    <tr>
                        <td colspan="5" style="font-weight: bold;">(A) ITC Available (whether in full or part)</td>
                    </tr>
                    <tr style="cursor: pointer;" *ngFor="let x of itcArr ">
                        <td class="pdngLeft">{{x.type}}</td>
                        <td style="text-align: right;"><input style="width: 100px; outline: none;" class="form-control brdr" [(ngModel)]="x.iamt" (keyup) ="changeitcArr($event)" (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px; outline: none;" class="form-control brdr" [(ngModel)]="x.camt" (keyup) ="changeitcArr($event)"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px; outline: none;" class="form-control brdr" [(ngModel)]="x.samt" (keyup) ="changeitcArr($event)" (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px; outline: none;" class="form-control brdr" [(ngModel)]="x.csamt" (keyup) ="changeitcArr($event)"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                    </tr>
                    <!-- <tr style="cursor: pointer;">
                        <td class="pdngLeft">(1) Import of Goods</td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                    </tr>
                    <tr style="cursor: pointer;">
                        <td class="pdngLeft">(3) Inward supplies liable to reverse charge (other than 1 & 2 above)</td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                    </tr>
                    <tr style="cursor: pointer;">
                        <td class="pdngLeft">(4) Inward supplies from ISD</td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                    </tr>
                    <tr style="cursor: pointer;">
                        <td class="pdngLeft">(5) All other ITC</td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                    </tr> -->

                    <!-- second -->
                    <tr>
                        <td colspan="5" style="font-weight: bold;">(B) ITC Reversed</td>
                    </tr>
                    <tr style="cursor: pointer;" *ngFor="let x of itcRevArr ">
                        <td class="pdngLeft">{{x.type}}</td>
                        <td style="text-align: right;"><input style="width: 100px; outline: none;" class="form-control brdr" [(ngModel)]="x.iamt" (keyup) ="changeitcRevArr($event)" (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px; outline: none;" class="form-control brdr" [(ngModel)]="x.camt" (keyup) ="changeitcRevArr($event)" (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px; outline: none;" class="form-control brdr" [(ngModel)]="x.samt" (keyup) ="changeitcRevArr($event)" (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px; outline: none;" class="form-control brdr"  [(ngModel)]="x.csamt" (keyup) ="changeitcRevArr($event)" (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                    </tr>
                    <!-- <tr style="cursor: pointer;">
                        <td class="pdngLeft">(2) Others</td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                    </tr> -->

                    <!-- third -->
                    <tr>
                        <td colspan="5" style="font-weight: bold;">(C) Net ITC Available (A)-(B)</td>
                    </tr>
                    <tr style="cursor: pointer;" *ngFor="let x of itcNetArr ">
                        <td class="pdngLeft">Total</td>
                        <td style="text-align: right;">
                                <!-- <input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"> -->
                        {{x.iamt | lacFormat}}
                        </td>
                        <td style="text-align: right;">
                                <!-- <input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text"> -->
                                {{x.camt | lacFormat}}</td>
                        <td style="text-align: right;">
                                <!-- <input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text">   -->  {{x.samt | lacFormat}} 
                        </td>
                        <td style="text-align: right;">
                                <!-- <input style="width: 100px;outline: none;" class="brdr"  (keypress)="CmnService.numberOnly($event)"
                                type="text">  -->
                                  {{x.csamt | lacFormat}}</td>
                    </tr>

                    <!-- fourth -->
                    <tr>
                        <td colspan="5" style="font-weight: bold;">(D) Ineligible ITC</td>
                    </tr>
                    <tr style="cursor: pointer;" *ngFor="let x of inEligibleArr ">
                        <td class="pdngLeft">{{x.type}}</td>
                        <td style="text-align: right;"><input style="width: 100px; outline: none;" class="form-control brdr" [(ngModel)]="x.iamt" (keyup) ="changeinEligibleArr($event)" (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px; outline: none;" class="form-control brdr" [(ngModel)]="x.camt" (keyup) ="changeinEligibleArr($event)" (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px; outline: none;" class="form-control brdr" [(ngModel)]="x.samt" (keyup) ="changeinEligibleArr($event)" (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 100px; outline: none;" class="form-control brdr" [(ngModel)]="x.csamt" (keyup) ="changeinEligibleArr($event)"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                    </tr>                    
                    <tr class="trBg" style="cursor: pointer;" *ngFor="let x of itcNetArr ">
                        <td >Total Net ITC Available</td>
                        <td style="text-align: right;"> {{x.iamt | lacFormat}}</td>
                        <td style="text-align: right;">{{x.camt | lacFormat}}</td>
                        <td style="text-align: right;">{{x.samt | lacFormat}}</td>
                        <td style="text-align: right;">{{x.csamt | lacFormat}}</td>
                    </tr> 
                </tbody>
            </table>


             <!-- table 4 -->
             <label style="margin-top:20px;width: 97%;" class="lblFont">5. Values of exempt, nil-rated and non-GST inward supplies</label>
            <table class="table table-borderd ngTable" data-show-filter="true" id="productListTbl"
                style="margin-bottom: 10px;width: 97%; background: white;">
                <thead>
                    <tr class="trBg">
                        <th>Nature of Supply</th>
                        <th style="width: 270px;">Inter-State Supplies</th>
                        <th style="width: 270px;">Intra-State Supplies</th>
                    </tr>
                </thead>
                <tbody>
                    <tr style="cursor: pointer;" *ngFor="let x of inwardSuppliesArr ">
                        <td>{{x.name}}</td>
                        <td style="text-align: right;"><input style="width: 270px; outline: none;" class="form-control brdr" [(ngModel)]="x.inter" (keyup) ="changeinwardSuppliesArr($event)"  (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                        <td style="text-align: right;"><input style="width: 270px; outline: none;" class="form-control brdr" [(ngModel)]="x.intra" (keyup) ="changeinwardSuppliesArr($event)" (keypress)="CmnService.numberOnly($event)"
                                type="text"></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>